export default {
  heroSlogan: 'Focused on cross-border services, integrating law, finance and business to escort enterprises going global',
  consultNow: 'Consult Now',
  learnMore: 'Learn More',
  advantageTitle1: '20+ Years Experience',
  advantageDesc1: 'Over 20 years in cross-border services, serving 100+ enterprises',
  advantageTitle2: 'Global Network',
  advantageDesc2: 'Service network covering 50+ countries and regions',
  advantageTitle3: 'Professional & Reliable',
  advantageDesc3: 'Professional legal, tax, and business team ensuring quality service',
  advantageTitle4: 'One-Stop Service',
  advantageDesc4: 'Full-process service from company registration to operation management',
}
